import { resolveMessageDescriptor } from './i18n_utils';

// Resolves the structured cut_line_label sent by the tournament results API:
//   { label: "Missed the cut" }                      -> shown verbatim
//   { key: "...", params: { score: "+3" } }          -> translated with params
//   { key: "...", params: { entities: { key: "..." } } } -> nested keys are
//     translated first, then interpolated (players/pairs/teams/... variants)
// The key form is the shared descriptor contract (see i18n_utils.js).
export const resolveCutLineLabel = (cutLineLabel) => {
  if (!cutLineLabel) return '';
  if (cutLineLabel.label) return cutLineLabel.label;

  return resolveMessageDescriptor(cutLineLabel);
};
